<template>
  <div>
    <Head title="Dashboard" />
    <h1>Dashboard</h1>
    <div class="row">
      <div class="col-md-6" v-if="auth.user.role_admin || auth.user.role_main_agent">
        <div class="content-box mb-3">
          <h2>New Requests</h2>
          <table class="table">
            <thead>
              <tr>
                <th>Booking #</th>
                <th>Agency</th>
                <th>Status</th>
                <th>Booking Date</th>
                <th>Customer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in requests.data" :key="request.id">
                <td>
                  <Link :href="`/bookings/${request.id}/edit`">
                    {{ request.booking_number }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/bookings/${request.id}/edit`">
                    {{ request.agency[0].name }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/bookings/${request.id}/edit`">
                    {{ request.status }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/bookings/${request.id}/edit`">
                    {{ $filters.formatDate(request.created_at) }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/bookings/${request.id}/edit`">
                    {{ request.customers[0].first_name }} {{ request.customers[0].middle_name }} {{ request.customers[0].last_name }}
                  </Link>
                </td>
              </tr>
              <tr v-if="requests.data.length === 0">
                <td colspan="5">No bookings found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-6" v-if="auth.user.role_admin">
        <div class="content-box mb-3">
          <h2>Totals</h2>
          <table class="table">
            <colgroup>
              <col width="20%">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <td scope="row">Customers</td>
                <th>{{ totals.customers }}</th>
              </tr>
              <tr>
                <td scope="row">Passengers</td>
                <th>{{ totals.passengers }}</th>
              </tr>
              <tr>
                <td scope="row">Agencies</td>
                <th>{{ totals.agencies }}</th>
              </tr>
              <tr>
                <td scope="row">Users</td>
                <th>{{ totals.users }}</th>
              </tr>
            </tbody>
          </table>
          <div class="mt-3">This year {{ new Date().getFullYear() }}: <span class="fw-bold">{{ totals.bookings }}</span> booked reservations</div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="content-box mb-3">
          <h2>Recent Bookings</h2>
          <table class="table">
            <thead>
              <tr>
                <th>Booking #</th>
                <th>Agency</th>
                <th>Status</th>
                <th>Route</th>
                <th>Booking Date</th>
                <th>Customer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="booking in bookings.data" :key="booking.id">
                <td>
                  <Link :href="`/${bookingLink}/${booking.id}/edit`">
                    {{ booking.booking_number }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/${bookingLink}/${booking.id}/edit`">
                    {{ booking.agency[0].name }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/${bookingLink}/${booking.id}/edit`">
                    {{ booking.status }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/${bookingLink}/${booking.id}/edit`" v-if="booking.journeys.length">
                    {{ findAirport(booking.journeys[0].departure.from)[0].iata }} - {{ findAirport(booking.journeys[0].departure.to)[0].iata }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/${bookingLink}/${booking.id}/edit`">
                    {{ $filters.formatDate(booking.created_at) }}
                  </Link>
                </td>
                <td>
                  <Link :href="`/${bookingLink}/${booking.id}/edit`">
                    {{ booking.customers[0].first_name }} {{ booking.customers[0].middle_name }} {{ booking.customers[0].last_name }}
                  </Link>
                </td>
              </tr>
              <tr v-if="bookings.data.length === 0">
                <td colspan="6">No bookings found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link
  },
  props: {
    requests: Object,
    bookings: Object,
    airports: Object,
    operators: Object,
    totals: Object
  },
  layout: Layout,
  computed: {
    auth() {
      return this.$page.props.auth
    },
    bookingLink() {
      if (this.auth.user.role_admin || this.auth.user.role_main_agent) {
        return 'bookings';
      } else {
        return 'agent-bookings'
      }
    }
  },
  methods: {
    findAirport(airportId) {
      return this.airports.filter(function(item){
          if(item.id == airportId) return item;
      })
    },
    findAirline(airlineId) {
      return this.operators.filter(function(item){
          if(item.id == airlineId) return item;
      })
    },
  },
}
</script>
